import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { CERTIFICATE_SVG } from "../../../utils/svgs";
import { AppButton } from "../../Generic/AppButton";
import { AppCard, AppCardContent } from "../../Generic/AppCard";
import { AppIcon } from "../../Generic/AppIcon";
import Flex from "../../Generic/Flex";
import { If } from "../../Generic/If";

interface Props {
  isOpen: boolean;
  canShare: boolean;
  onClickShare: () => void;
  onClickOpen: () => void;
}

const TrainingCenterBundleCertificate = (props: Props) => {
  if (!props.isOpen) {
    return <></>;
  }

  return (
    <AppCard variant="soft" className="TrainingCenterBundleCertificate">
      <AppCardContent>
        <Flex alignItems="center" justifyContent="space-between">
          <Flex direction="column" yGap={4}>
            <span className="title">{translate(STRINGS.CONGRATULATIONS)}</span>
            <span className="subtitle">{translate(STRINGS.YOU_GOT_THE_CERTIFICATE)}</span>
          </Flex>

          <AppIcon icon={CERTIFICATE_SVG} size={32} />
        </Flex>

        <div className="buttons-container">
          <If condition={props.canShare}>
            <AppButton
              className="share-certificate-button"
              color="success"
              size="small"
              onClick={props.onClickShare}
            >
              {translate(STRINGS.SHARE_WITH_YOUR_FRIENDS)}
            </AppButton>
          </If>
          <AppButton
            className="open-certificate-button"
            variant="link"
            size="small"
            onClick={props.onClickOpen}
            textColor="gray-500"
          >
            {translate(STRINGS.OPEN)}
          </AppButton>
        </div>
      </AppCardContent>
    </AppCard>
  );
};

export default TrainingCenterBundleCertificate;
